module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_019"
    }
  }, [_vm._v("Out of necessity, Grumman and Swirbul, the company president and vice president, shared an office with facing desks. They didn’t always agree and sometimes even argued loudly. However, they always hammered out their differences before leaving the office, often going down to the shop floor to help the workers buck rivets or bend metal.")])]), _c('a', {
    attrs: {
      "id": "file_019"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcd4e73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_019.vue
// module id = 108
// module chunks = 0